// The harbour city, made live: waves rolling in, a low traffic hum, and every few seconds a gull, a ship's horn, a car
// horn or a crane clanking somewhere on the Docks.
import { audioCtx, hiss, noise, tone } from "./ctx";

const VOL = 0.5;
let bus, sources = [], timer;

function loop(c, brown, filter, freq, gain) {
  const s = c.createBufferSource(), f = c.createBiquadFilter(), g = c.createGain();
  s.buffer = noise(c, brown);
  s.loop = true;
  f.type = filter;
  f.frequency.value = freq;
  g.gain.value = gain;
  s.connect(f).connect(g).connect(bus);
  s.start();
  sources.push(s);
  return g;
}

const gull = (t) => {
  for (let i = 0; i < 2 + Math.floor(Math.random() * 3); i++) {
    const at = t + i * (0.22 + Math.random() * 0.12), f = 1700 + Math.random() * 700;
    tone(bus, { type: "triangle", freq: f, to: f * 0.62, t: at, peak: 0.035, attack: 0.03, end: 0.2 });
  }
};
const shipHorn = (t) => [92, 138].forEach((freq) => tone(bus, { type: "sawtooth", freq, t, peak: 0.03, attack: 0.25, end: 2.4 }));
const carHorn = (t) => [0, 0.2].forEach((d) => [415, 523].forEach((freq) => tone(bus, { type: "square", freq, t: t + d, peak: 0.006, end: 0.14 })));
const clank = (t) => [0, 0.16, 0.3].forEach((d) => hiss(bus, { t: t + d, freq: 900 + Math.random() * 900, q: 9, peak: 0.05, end: 0.12 }));
const EVENTS = [gull, gull, gull, shipHorn, carHorn, carHorn, clank];

function schedule() {
  timer = setTimeout(() => {
    EVENTS[Math.floor(Math.random() * EVENTS.length)](bus.context.currentTime + 0.05);
    schedule();
  }, 2500 + Math.random() * 6000);
}

export function startCity() {
  if (bus) return;
  const c = audioCtx();
  const lowpass = c.createBiquadFilter();
  lowpass.type = "lowpass";
  lowpass.frequency.value = 2400;
  lowpass.connect(c.destination);
  bus = c.createGain();
  bus.gain.setValueAtTime(0.0001, c.currentTime);
  bus.gain.exponentialRampToValueAtTime(VOL, c.currentTime + 2);
  bus.connect(lowpass);
  const waves = loop(c, false, "lowpass", 420, 0.06);
  const swell = c.createOscillator(), depth = c.createGain();
  swell.frequency.value = 0.11;
  depth.gain.value = 0.05;
  swell.connect(depth).connect(waves.gain);
  swell.start();
  sources.push(swell);
  loop(c, true, "lowpass", 200, 0.22);
  schedule();
}

export function stopCity() {
  if (!bus) return;
  const b = bus, s = sources, t = b.context.currentTime;
  clearTimeout(timer);
  b.gain.setValueAtTime(b.gain.value, t);
  b.gain.exponentialRampToValueAtTime(0.0001, t + 0.8);
  setTimeout(() => { s.forEach((x) => x.stop()); b.disconnect(); }, 900);
  bus = null;
  sources = [];
}
